import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { QuestionCircleOutlined} from '@vicons/antd';
import { renderIcon } from '@/utils/index';

const routeName = 'help';
const IFrame = () => import('@/views/iframe/index.vue');
const routes: Array<RouteRecordRaw> = [
  {
    path: '/help',
    name: routeName,
   // redirect: '/help/console',
    component: Layout,
    meta: {
      title: 'Help',
      icon: renderIcon(QuestionCircleOutlined),
      
      //permissions: ['dashboard_console', 'dashboard_console', 'dashboard_workplace'],
      sort: 9,
      isRoot: true,
      activeMenu: 'help_index',
      alwaysShow: true,
     
    },
    children: [
      {
        path: 'index',
        name: 'https://healthbc.sharepoint.com/sites/VCHFMOpsVCH/PCT/SitePages/TrainingHome.aspx',
        meta: {
          title: 'Help',
          icon: renderIcon(QuestionCircleOutlined),
          //permissions: ['dashboard_console'],
          affix: true,
          hidden: true,
          //frameSrc: 'https://healthbc.sharepoint.com/:b:/r/sites/VCHFMOpsVCH/PCT/Shared%20Documents/Project%20Cost%20Tracking%20App%20Training%20Guide.pdf?csf=1&web=1&e=pWO1GZ',
        },
       
       component: IFrame,
      },
     
     
    ],
  },
];

export default routes;
